import { useEffect, useState } from "react";
import { FileDown } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { fetchDocumentBlobUrl, openDocument } from "@/lib/documents";

export function InlineDocumentPreview({ documentId, label, onClose }) {
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    let url;
    if (!documentId) return undefined;
    setState({ loading: true });
    fetchDocumentBlobUrl(documentId).then((r) => { url = r.url; setState({ loading: false, ...r }); }).catch((e) => setState({ loading: false, error: e.message }));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [documentId]);
  return (
    <Dialog open={!!documentId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="inline-document-preview" className="max-w-4xl">
        <DialogHeader><DialogTitle className="flex items-center justify-between gap-3 pr-6 text-jigsaw-navy"><span className="truncate">{label || state.title || "Document"}</span>
          <Button size="sm" variant="outline" data-testid="inline-preview-open-new-tab" onClick={() => openDocument(documentId)}><FileDown className="mr-1 h-3.5 w-3.5" /> Open in new tab</Button></DialogTitle></DialogHeader>
        {state.loading && <p data-testid="inline-preview-loading" className="py-10 text-center text-sm text-jigsaw-muted">Fetching the signed document…</p>}
        {state.error && <p data-testid="inline-preview-error" className="py-10 text-center text-sm text-jigsaw-danger">Could not load this document: {state.error}</p>}
        {state.url && <iframe title={state.title || "Document preview"} src={state.url} className="h-[70vh] w-full rounded-md border border-jigsaw-border bg-white" />}
      </DialogContent>
    </Dialog>
  );
}
